/* eslint-disable quote-props */
<template>
  <span
    v-if="value !== 'undefined'"
    :class="classList"
  >
    {{ statuses[value].label }}
  </span>
</template>
<script>
export default {
  props: {
    value: {
      type: [Number, String],
      default: 0,

    },
  },

  data: () => ({
    statuses: {
      0: { label: 'Offline', className: 'red darken-3' },
      1: { label: 'Online', className: 'green accent-4' },
      2: { label: 'On order', className: 'blue-grey darken-1' },
      3: { label: 'Searching', className: 'orange darken-3' },
    },
  }),

  computed: {
    classList() {
      return ['status', this.value !== 'undefined' ? this.statuses[this.value].className : ''];
    },
  },

};
</script>

<style lang="scss" scoped>
  .status {
    padding: 5px 10px;
    border-radius: 5px;
    color: #fff;
  }
</style>
